export type SiteMode = "platform" | "standalone";

const rawSiteMode = process.env.REACT_APP_SITE_MODE?.trim() || "platform";

export const SITE_MODE: SiteMode =
  rawSiteMode === "standalone" ? "standalone" : "platform";

export const IS_STANDALONE = SITE_MODE === "standalone";

const publicUrl = process.env.PUBLIC_URL || "";

export const STANDALONE_SPACE_ID_CONFIG_FILE = "src/site-config/SiteConfig.ts";

export const STANDALONE_SPACE_ID_ENV_KEY = "standaloneSite.spaceId";

function toPublicAsset(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${publicUrl}${normalized}`;
}

/** 独立站：品牌、空间号、页面文案、法律文档变量等，统一在此修改 */
export const standaloneSite = {
  spaceId: "83729389",
  brandLogo: "/standonletactik/tactik.png",
  favicon: "/standonletactik/tactik.png",
  siteTitle: "TACTIK-做自己的私募经理",
  /** 网站名称（用户协议、隐私政策等法律文档引用） */
  brandName: "TACTIK",
  /** 运营主体公司名称（页脚、法律文档引用） */
  companyName: "上海魔法向量人工智能技术有限公司",
  /** 网站域名（法律文档引用） */
  websiteDomain: "www.tactik.cn",
  slogan: "做自己的私募经理",
  welcome_words: "专业理性投资，从这里开始",
  app_introduction: "一站式自投资学习和成长平台",
} as const;

/** 平台站配置 */
export const platformSite = {
  brandLogo: "/logo.png",
  brandName: "龙粉社",
  tagline: "财经资讯和知识分享平台",
  showChineseWordmark: true,
} as const;

/** 按站点模式解析后的展示配置 */
export const siteConfig = {
  shellLogo: toPublicAsset(
    IS_STANDALONE ? standaloneSite.brandLogo : platformSite.brandLogo
  ),
  shellLogoAlt: IS_STANDALONE
    ? standaloneSite.brandName
    : platformSite.brandName,
  showChineseWordmark: !IS_STANDALONE && platformSite.showChineseWordmark,
  shellTagline: IS_STANDALONE ? "" : platformSite.tagline,
  shellBrandNavLabel: IS_STANDALONE
    ? `${standaloneSite.brandName}-${standaloneSite.slogan}`
    : "",
  appIntroduction: IS_STANDALONE ? standaloneSite.app_introduction : "",
  welcomeWords: IS_STANDALONE ? standaloneSite.welcome_words : "",
};

const STANDALONE_SPACE_ID_ERROR = `独立站须在 ${STANDALONE_SPACE_ID_CONFIG_FILE} 中配置 ${STANDALONE_SPACE_ID_ENV_KEY}（8 位数字）`;

/** 独立站固定空间号；平台模式返回空串 */
export function getStandaloneSpaceId(): string {
  if (!IS_STANDALONE) {
    return "";
  }
  const spaceId = standaloneSite.spaceId.trim();
  if (!/^\d{8}$/.test(spaceId)) {
    throw new Error(STANDALONE_SPACE_ID_ERROR);
  }
  return spaceId;
}

/** 独立站：同步设置页面标题与 favicon（构建时 index.html 仍为平台默认值） */
export function applySiteDocumentMeta(): void {
  if (!IS_STANDALONE) {
    return;
  }

  document.title = standaloneSite.siteTitle;

  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/png";
    document.head.appendChild(link);
  }
  link.href = toPublicAsset(standaloneSite.favicon);
}
